<template>
    <div class="position-relative">
      <label for="id_cashcall-management-filter-create-date" class="d-block"
        >Created Date</label
      >
      <DatePicker
        v-model="modelValue"
        :input-attr="{ id: 'id_cashcall-management-filter-create-date' }"
        range
      />
    </div>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'
  import DatePicker from 'vue2-datepicker'
  
  export default defineComponent({
    name: 'CashCallManagementTableFiltersCreateDate',
    components: {
      DatePicker
    },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    emits: ['input'],
    setup(props, { emit }) {
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })
  
      return {
        modelValue
      }
    }
  })
  </script>
  
  <style scoped>
  .mx-datepicker {
    width: 100%;
    max-width: 140px;
    min-width: auto;
  }
  
  .mx-datepicker >>> .mx-input-wrapper input {
    border-color: #e9ecef;
    border-radius: 4px;
  }
  </style>
  